import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=4f357e7e&scoped=true&"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=4f357e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f357e7e",
  null
  
)

export default component.exports